import { Link } from "react-router-dom";
import { Instagram, Youtube, Twitter } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="main-footer" className="border-t border-white/10 bg-black">
      <div className="mx-auto max-w-7xl px-6 py-16">
        <p
          data-testid="footer-brand"
          className="text-outline-white font-anton text-[13vw] leading-none md:text-[8vw]"
        >
          SOUTHERN SMOKE
        </p>

        <div className="mt-12 flex flex-col justify-between gap-10 md:flex-row md:items-end">
          <div className="flex gap-8 font-mono text-xs tracking-[0.25em] text-white/60">
            <Link to="/music" data-testid="footer-link-music" className="transition-colors duration-300 hover:text-primary">MUSIC</Link>
            <Link to="/merch" data-testid="footer-link-merch" className="transition-colors duration-300 hover:text-primary">MERCH</Link>
            <Link to="/about" data-testid="footer-link-about" className="transition-colors duration-300 hover:text-primary">ABOUT</Link>
            <Link to="/label" data-testid="footer-link-label" className="transition-colors duration-300 hover:text-primary">LABEL</Link>
            <Link to="/gallery" data-testid="footer-link-gallery" className="transition-colors duration-300 hover:text-primary">GALLERY</Link>
            <Link to="/contact" data-testid="footer-link-contact" className="transition-colors duration-300 hover:text-primary">CONTACT</Link>
            <Link to="/subscribe" data-testid="footer-link-subscribe" className="transition-colors duration-300 hover:text-primary">SUBSCRIBE</Link>
            <Link to="/admin" data-testid="footer-link-admin" className="transition-colors duration-300 hover:text-primary">ADMIN</Link>
          </div>

          <div className="flex items-center gap-5">
            <a href="https://instagram.com" target="_blank" rel="noreferrer" data-testid="footer-social-instagram" aria-label="Instagram"
               className="border border-white/15 p-3 text-white/70 transition-colors duration-300 hover:border-primary hover:text-primary">
              <Instagram size={18} />
            </a>
            <a href="https://youtube.com" target="_blank" rel="noreferrer" data-testid="footer-social-youtube" aria-label="YouTube"
               className="border border-white/15 p-3 text-white/70 transition-colors duration-300 hover:border-primary hover:text-primary">
              <Youtube size={18} />
            </a>
            <a href="https://twitter.com" target="_blank" rel="noreferrer" data-testid="footer-social-twitter" aria-label="Twitter"
               className="border border-white/15 p-3 text-white/70 transition-colors duration-300 hover:border-primary hover:text-primary">
              <Twitter size={18} />
            </a>
          </div>
        </div>

        <div className="mt-12 flex flex-col justify-between gap-3 border-t border-white/10 pt-6 font-mono text-[10px] tracking-[0.25em] text-white/40 md:flex-row">
          <span data-testid="footer-copyright">© 2026 MIKE MILLZZ — SOUTHERN SMOKE MUSIC GROUP</span>
          <span data-testid="footer-handle">@MIKE_MILLZZ_</span>
        </div>
      </div>
    </footer>
  );
}
